export const environment = {
  PRODUCTION: false,
  PORT: 4000,
  BASE_ENV_URL: 'https://c4stg1ccg.carhartt.com',

  // OCC
  API_BASE_URL: 'https://api-c4stg1ccg.carhartt.com',
  API_PREFIX: '/ws/v2/',

  // CDC
  CDC_API_KEY: '4_FmvXFg9995LmwMdEA965dw',
  CDC_API_URL: 'https://cdns.us1.gigya.com/js/gigya.js',
  CDC_API_SAPTCHA: true,

  // SSR
  ssrCache: true,
  // ssrCacheSizeMemory: 800000000,
  concurrency: 20,
  timeout: 6000,
  ttl: 300000,
  maxRenderTime: 30000,

  // CHAT
  salesforceBaseCoreURL: 'https://carhartt--uat.sandbox.my.salesforce.com',
  salesforceChatSetAttribute: 'https://service.force.com/embeddedservice/5.0/esw.min.js',
  salesforceInitChatUrl: 'https://carhartt--uat.sandbox.my.salesforce.com',
  salesforceSecondInitChatUrl: 'https://carhartt--uat.sandbox.my.salesforce-sites.com/',
  salesforceBaseLiveAgentURL: 'https://d.la12s-core1.sfdc-yfeipo.salesforceliveagent.com/chat',
  salesforceBaseLiveAgentContentURL: 'https://c.la12s-core1.sfdc-yfeipo.salesforceliveagent.com/content',
  salesforceWebToCaseURL: 'https://carhartt--uat.sandbox.my.salesforce.com/servlet/servlet.WebToCase',
  salesforceOrgId: '00DOu00000B80Md',
  salesforceChatId: '00DgP00000043tl',
  salesforceButtonId: '5730h0000008QkI',
  salesforceDeploymentId: '5720h0000008Qg6',
  salesforceEmbeddedService: 'embedded_svc',
  salesforceEswLiveAgentDevName: 'CCG',
  salesforceEmbeddedServiceBootStrapLanguage: 'en_US',
  salesforceEmbeddedServiceBootStrap: 'embeddedservice_bootstrap',
  salesforceMiawOrgId: '00DOu00000B80Md',
  salesforeceMiawEsConfigName: 'Enhanced_CCG_Chat',
  salesforceMiawSiteURL: 'https://carhartt--uat.sandbox.my.site.com/ESWEnhancedCCGChat1757988248227',
  salesforceMiawScrt2URL: 'https://carhartt--uat.sandbox.my.salesforce-scrt.com',

  salesforceWebToCaseForm: {
    recordType: '0120h000000CF7J',
    reason: 'reason',
    subject: 'subject',
    description: 'description',
    firstName: '00NPY0000056CbV',
    lastName: '00NPY0000056Chx',
    country: '00NPY0000056ClB',
    email: 'email',
    orderNumber: '00NPY000005iGNz',
    phone: 'phone'
  },
  // SCENE 7
  scene7baseURL: 'https://imgcdn.carhartt.com/is/image/Carhartt/',
  scene7primaryImageBaseURL: 'https://imgcdn.carhartt.com/is/image/',
  scene7VideoBaseURL: 'https://imgcdn.carhartt.com/is/content/',
  scene7primaryImageKey: '$pdp-primary-image-static$',
  scene7thumbnailImageKey: '$cart-item-desktop-retina$',
  scene7ProductImageKey: '$400L2$',
  scene7swatchPictureParam: '$product-cell-color-swatch$',
  scene7StaticImageThumbnailsUrlEnd: '?$pdp-thumbnail$',
  scene7MainStaticImageUrlEnd: '?fit=constrain,1&wid=798&hei=800&fmt=jpg',

  // TRUEFIT
  truefitUrl: 'scripts/truefit/fitrec-stage.js',
  truefitClientId: 'ccg',

  // TURNTO
  turnToWidgetsUrl: 'https://widgets.turnto.com/v5/widgets/',
  turnToClientId: '1OExFFZh8kv8eTXsite',

  // SPECTRUM CUSTOMIZER
  spectrumBaseUrl: 'https://cdn-staging.spectrumcustomizer.com/carhartt/v3/frontend/js/customizer.min.js',
  spectrumDesignUrl: 'https://cdn-staging.spectrumcustomizer.com/carhartt/v3/frontend/index.html?recipeId=',
  spectrumDesignUrlNonEditable: 'https://staging-client.spectrumcustomizer.com/carhartt/design/',

  // IDME
  idMeAuthorizeUrl: 'https://groups.id.me/?client_id=',
  idMeClientId: '46b486e85ee7a004e42c616d9660e85e',
  idMeScope: 'military,responder,nurse,medical',
  idMeWidgetURL: 'https://s3.amazonaws.com/idme/developer/idme-buttons/assets/js/idme-wallet-button.js',

  // CYBERSOURCE
  cybersourceFraudDeviceFingerPrintOrgId: '1snn5n9w',
  cybersourceMerchantId: 'carhartt_ccg',
  cybersourceFraudJsSrcBeginning: 'https://h.online-metrix.net/fp/tags.js?org_id=',
  cybersourceFraudJsSrcMiddle: '&session_id=',

  // TEALIUM
  enableTealium: true,
  tealiumEnvironment: 'qa',
  tealiumAccount: 'carhartt',
  tealiumProfile: 'd2b',

  // SSR Options
  headerContentSecurityPolicy: 'frame-ancestors \'self\' http://localhost:*',
  headerStrictTransportSecurity: 'max-age=31536000; includeSubDomains'
}
